import { Tag } from 'antd';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './index.less';

const cx = classNames.bind(styles);

const defaultProps = {
  disabled: false,
};
const propTypes = {
  id: PropTypes.number.isRequired,
  label: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
  ]).isRequired,
  disabled: PropTypes.bool,
};

const SimpleTag = ({
  id,
  label,
  disabled,
}) => (
  <Tag className={`text-center ${cx('tag')} ${disabled ? cx('disabled') : ''}`}>
    {id}-{label}
  </Tag>
);

SimpleTag.defaultProps = defaultProps;
SimpleTag.propTypes = propTypes;
export default SimpleTag;



// WEBPACK FOOTER //
// ./src/components/ui/Tags/SimpleTag.jsx